import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import { Icon, message } from 'antd';

import './style.css';

const MAX_VIDEO_SIZE = 40000000; //40MB
const ACCEPTED_EXTENSIONS = '.avi,.mp4,.mov,.mpg';

export function describeRejection(file) {
  if (file.size > MAX_VIDEO_SIZE) {
    return `Dateigröße von ${file.name} übersteigt das Limit von ${MAX_VIDEO_SIZE / 1000000}MB.`;
  }
  return `${file.name} wird nicht unterstützt. Erlaubt sind ${ACCEPTED_EXTENSIONS.split(',').join(', ')} bis ${
    MAX_VIDEO_SIZE / 1000000
  }MB.`;
}

class VideoDropzone extends Component {
  onFilesAccept = (files) => {
    if (this.props.onFileSelected) {
      this.props.onFileSelected(files);
    }
  };

  onFilesRejected = (files) => {
    const reasons = files.map(describeRejection);

    // Without a handler fall back to the toast; the handler can show the reason persistently.
    if (this.props.onFileRejected) {
      this.props.onFileRejected(reasons.join(' '));
      return;
    }

    reasons.forEach((reason) => message.error(reason));
  };

  render() {
    const { shape, icon } = this.props;

    return (
      <Dropzone
        id="VideoDropzone"
        className={`overlay ${shape}`}
        accept={ACCEPTED_EXTENSIONS}
        maxSize={MAX_VIDEO_SIZE}
        multiple={this.props.multiple}
        onDropRejected={this.onFilesRejected}
        onDropAccepted={this.onFilesAccept}
      >
        <div style={{ position: 'relative', height: '100%' }}>
          <Icon type={icon} className="upload-icon" />
        </div>
      </Dropzone>
    );
  }
}

VideoDropzone.propTypes = {
  onFileSelected: PropTypes.func,
  onFileRejected: PropTypes.func,
  shape: PropTypes.string,
  multiple: PropTypes.bool,
  icon: PropTypes.string,
};

VideoDropzone.defaultProps = {
  multiple: false,
  icon: 'video-camera',
};

export default VideoDropzone;
